const { postData, getData } = require('js/api/getdata').default
/**
 * 存放有关权限的所有config数据
 */
const APPROVE_CONFIG = {
  APPROVE_ACTION_MASK: [
    { zh: '删除', en: 'remove', num: '64' },
    { zh: '链接', en: 'delivery', num: '24' },
    { zh: '下载', en: 'download', num: '4' },
    { zh: '上传', en: 'upload', num: '2' },
  ],
  FORBIDDEN_ATOM_AUTHORITY: [
    { zh: '禁止复制', num: '512' },
    { zh: '禁止移动', num: '256' },
    { zh: '禁止重命名', num: '128' },
    { zh: '禁止删除', num: '64' },
    { zh: '禁止链接', num: '24' },
    { zh: '禁止下载', num: '4' },
    { zh: '禁止上传', num: '2' },
    { zh: '禁止预览', num: '1' },
  ],
  DLP_APPROVE_MASK: [
    { type: 'delete', num: '64' },
    { type: 'link', num: '24' },
    { type: 'download', num: '4' },
  ],

}

/**
 * 日志中各个空间对应的参数值
 * @param {String} pathType - 空间类型
 * @return {Number}
 */
const isWhereFromSetPythType = (pathType) => {
  switch (pathType) {
    case 'ent':
      return 1
    case 'self':
      return 2
    case 'share_out':
      return 3
    case 'share_in':
      return 4
    default:
      return 0
  }
}
/**
 * 记录日志
 * @param {Object} params
 * @param {Number} params.category
 * @param {Number} params.action
 * @param {Number} params.nsid
 * @param {String} params.pathType
 * @param {String} params.neid
 * @param {String} params.entityStr1
 * @param {String} params.entityStr2
 * @param {String} params.entityStr3
 * @param {String} params.type
 */
export const sendLogBuryingPointMethods = (params) => {
  const {
    category, action, nsid, pathType,
    neid, entityStr1, entityStr2, entityStr3,
    type,
  } = params
  const postDataForLog = {
    category,
    action,
    nsid,
    pathType: isWhereFromSetPythType(pathType),
  }
  if (neid) {
    postDataForLog.neid = neid
  }
  if (entityStr1) {
    postDataForLog.entityStr1 = entityStr1
  }
  if (entityStr2) {
    postDataForLog.entityStr2 = entityStr2
  }
  if (entityStr3) {
    postDataForLog.entityStr3 = entityStr3
  }
  if (type && type === 'batch') { // 批量创建日志
    postDataForLog.arrayFormat = true
    return postData('batchLogging', postDataForLog)
  }
  return postData('log', postDataForLog) // 单个日志
}
/**
 * 审批权限换算
 * @param maskArg
 * @return {Object}
 */
export const approveMask = function (maskArg) {
  let mask = maskArg
  const maskList = []
  const nameList = []
  const enList = []
  const maskNum = []
  // 增加兼容审批行为的功能
  const propObj = {}
  for (let i = 0; i < APPROVE_CONFIG.APPROVE_ACTION_MASK.length; i += 1) {
    const temp = APPROVE_CONFIG.APPROVE_ACTION_MASK[i]
    if (parseInt(mask, 10) >= parseInt(temp.num, 10)) {
      maskList.push(temp)
      maskNum.push(parseInt(temp.num, 10))
      nameList.push(temp.zh)
      enList.push(temp.en)
      propObj[temp.en] = true
      mask = parseInt(mask, 10) - parseInt(temp.num, 10)
    }
  }
  return {
    mask: maskList,
    name: nameList,
    prop: propObj,
    ename: enList,
    maskNum,
  }
}

/**
 * 查询审批规则
 * @param {Object} paramsParam
 * @param {number} paramsParam.neid neid
 * @param {number} paramsParam.nsid nsid
 * @param {number} paramsParam.path 路径
 * @param {string|array} policetype
 */
export const isExistPolicy = (paramsParam, policetype) => new Promise((resolve, reject) => {
  const params = paramsParam
  if (params.path) {
    params.target_path = params.path
  }
  postData('isExistPolicy', params).then(({ data, status }) => {
    if (policetype === 'delivery') {
      data.content = [{
        approvePdm: 24,
        approve_uids: [{
          email: "admin@admin.com",
          id: 27,
          name: "提交后请在EIP系统查看审批进度，路径为：EIP首页>工作台>最近提交",
          p_id: 11,
        }],
        create_uid: 27,
        dlpPdm: 0,
        id: 11,
        nsid: 1,
        path: data.path,
        pdm: 24,
      }]
    }
    if (status === 200 && data.content && data.content.length > 0) {
      const { dlpPdm, id } = data.content[0]
      const canDlpApply = !!approveMask(dlpPdm).prop[data.type]
      const taskType = canDlpApply ? 2 : 1
      const approveMasks = approveMask(data.content[0].pdm)
      // TODO:私有-需要检查没有审批着等情况，没有匹配的审批规则
      const errorInfo = {
        policy_id: id || 0,
        task_type: taskType,
      }
      if (typeof policetype === 'string' && approveMasks.prop[policetype]) {
        reject(new Error(JSON.stringify(errorInfo)))
      } else if (Array.isArray(policetype)) {
        for (const typeitem of policetype) {
          if (approveMasks.prop[typeitem]) {
            return reject(new Error(JSON.stringify(errorInfo)))
          }
        }
        resolve({ data, approveMasks })
      } else {
        resolve({ data, approveMasks })
      }
    } else {
      resolve({ data, status })
    }
  }).catch((error) => reject(error))
})

/**
   * 查询审批者名单
   * @param {Object} paramsApprover
   * @param {String} paramsApprover.policyId
   * @param {String} paramsApprover.taskType
   */
export const getPolicyApprover = (paramsApprover) => getData('getPolicyApprover', paramsApprover)

/**
 * 用于查询文件是否还存在
 *  @param {Object} paramsFileInfo
 *  @param.path {String} paramsFileInfo.path
 *  @para.path_type {String} paramsFileInfo.path_type
 * */
export const ifFileExist = (paramsFileInfo) => postData('fileExists', paramsFileInfo)
export const doFileExistJob = (paramsFileInfo) => new Promise((resolve) => {
  ifFileExist(paramsFileInfo)
    .then(resolve)
    .catch((error) => {
      if (error && error.response) {
        const { data: { status } } = error.response
        if (status === 404) {
          window.store.commit('SET_REQUEST_STATUS', `${status}_${new Date().getTime()}`)
        }
      }
    })
})
